import * as React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components/macro";

import {
  Link as MuiLink,
  Grid,
  Typography as MuiTypography,
} from "@mui/material";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(6)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const Typography = styled(MuiTypography)`
  color: ${(props) => props.theme.footer.color};
`;

const Link = styled(MuiLink)`
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container item xs={12} md={6} alignItems="center" spacing={4}>
        <Grid item>
          <Link component={NavLink} to="/" color="default">
            <Typography variant="body1">Privacy</Typography>
          </Link>
        </Grid>
        <Grid item>
          <Link component={NavLink} to="/">
            <Typography variant="body1">Terms of Service</Typography>
          </Link>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
